import Vue from "vue";
import "./plugins/vuetify";
import vPlayBack from "v-playback";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.use(vPlayBack);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
